import { Reveal, SectionTag } from "./shared";

const windows = [
  { tag: "Pre-LOI / Diligence", text: "Know what recoverable working capital is worth before you underwrite the deal. Seven days, before management access questions arise." },
  { tag: "First 100 Days", text: "Replace the generic ops workstream. You open the hold with a quantified, sequenced 90-day cash recovery plan that your team owns from day one." },
  { tag: "Mid-Hold / Revenue Plateau", text: "When EBITDA growth has stalled and the functional levers are spent — recoverable working capital is the last distribution you haven't pulled." },
  { tag: "Pre-Exit", text: "Convert final trapped cash into a working capital step-down. Improves multiples. Improves ROIC on the entire hold." },
];

export const Windows = () => (
  <section id="windows" className="py-12 lg:py-16 bg-[#f7f9fa] dot-grid" data-testid="windows-section">
    <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
      <SectionTag num="03" label="When To Run It" />
      <Reveal>
        <h2 className="font-display font-extrabold text-[#0B1B2B] tracking-[-0.02em] leading-[1.05] text-3xl sm:text-4xl lg:text-[44px] max-w-[800px]">
          Four opportunities to find <span className="text-[#0E5F46]">Trapped Cash.</span>
        </h2>
      </Reveal>
      <div className="mt-8 grid md:grid-cols-2 gap-5">
        {windows.map((w, i) => (
          <Reveal key={w.tag} delay={0.08 * i}>
            <div className="group relative h-full p-8 lg:p-10 rounded-2xl bg-white border border-[#0B1B2B]/8 hover:shadow-[0_24px_60px_rgba(11,27,43,0.1)] hover:-translate-y-1 transition-all duration-500 overflow-hidden" data-testid={`window-card-${i + 1}`}>
              <span className="absolute -top-4 right-5 font-display font-extrabold text-[88px] leading-none text-[#0B1B2B]/[0.05] group-hover:text-[#0E5F46]/10 transition-colors duration-500 select-none">
                {i + 1}
              </span>
              <span className="inline-block px-5 py-2.5 rounded-full bg-[#0E5F46]/10 text-[#0E5F46] text-xl lg:text-2xl font-display font-bold tracking-[0.03em] uppercase">
                {w.tag}
              </span>
              <p className="mt-5 text-[#3c4a58] leading-relaxed text-[17px] lg:text-lg max-w-[520px]">{w.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
